module.exports = __webpack_public_path__ + "img/rp-misc-logo-inverse.5bb3c00d.png";